import React from 'react';
import { useDefaultOnReset } from './error-boundary.hooks';
import { defaultErrorHandler } from './error-boundary.utils';
import ErrorFallback from './error-fallback/error-fallback.component';
import TestError from './test-error/test-error.component';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';

const ErrorBoundary = ({
  name,
  FallbackComponent = ErrorFallback,
  onError = defaultErrorHandler(name),
  onReset,
  children,
  ...rest
}) => {
  const defaultOnReset = useDefaultOnReset();

  return (
    <SentryErrorBoundary
      fallback={({ resetError, ...fallbackProps }) => (
        <FallbackComponent resetErrorBoundary={resetError} {...fallbackProps} />
      )}
      onError={onError}
      onReset={onReset || defaultOnReset}
      {...rest}
    >
      <TestError name={name} />
      {children}
    </SentryErrorBoundary>
  );
};

export default ErrorBoundary;
